import { render, staticRenderFns } from "./StartQuiz.vue?vue&type=template&id=646aefb3&scoped=true&"
import script from "./StartQuiz.vue?vue&type=script&lang=js&"
export * from "./StartQuiz.vue?vue&type=script&lang=js&"
import style0 from "./StartQuiz.vue?vue&type=style&index=0&id=646aefb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646aefb3",
  null
  
)

export default component.exports